import { atom } from 'recoil'

export const interactState = atom({
    key: 'interactState',
    default: [],
});